<script>
  import { contactService } from "../../services";
  import { required ,requiredIf} from "vuelidate/lib/validators";
  import config from "../../config";
  import { error_message, success_message } from "../../Helper/helper";
  import Layout from "../../layouts/main";
  import PageHeader from "../../components/page-header";

  export default {
    components: { contactService,Layout,PageHeader, config },
    data() {
      return {
        typeform: {
          type: "",
          company_name: "",
          company_branch: "",
          user_name: "",
          role: "",
          relationship: "",
          address: "",
          email: "",
          private_email: "",
          phone_number1: "",
          mobile_phone_number: "",
          private_number: "",
          fax_number: "",
          url: "",
          note: "",
          status: 1,
        },
      };
    },
    validations: {
      typeform: {
        type: { required },
        role: { required },
        user_name: {
          required: requiredIf(function () {
            return this.typeform.type === "0"; // Ensure that "this" is correctly referencing typeform
          }),
        },
      },
    },
    methods: {
    getContactId() {
      contactService
        .getContactById({ id: this.$route.params.id })
        .then((response) => {
          console.log(response.data.result);
          this.typeform = response.data.result;
          this.typeform.contact_id = this.$route.params.id;
        });
    },

    editContact() {
      this.$v.typeform.$touch();
      if (this.$v.typeform.$invalid) {
        return;
      } else {
        const fd = new FormData();
        contactService.updateContact({ ...this.typeform }).then((response) => {
          if (response.data.code === 200) {
            success_message(response.data.message);
            this.$router.push({ name: "contacts-list" });
          } else {
            error_message(response.data.message);
          }
        });
      }
    },
  },

  mounted() {
    this.getContactId();
  },
};
</script>


  <template>
    <Layout>
        <div class="row">
            <div class="col-12">
                <div class="page-title-box d-flex align-items-center justify-content-between icon-main-page">
                    <div class="page-title-left avatar-main-icon">
                        <div class="avatar-xs mr-3">
                            <span
                                class="
                                avatar-title
                                rounded-circle
                                bg-soft-primary
                                text-primary
                                font-size-18
                                "
                            >
                                <i class="bx bx-briefcase"></i>
                            </span>
                        </div>
                        <div class="report-tag">
                            <h4 class="mb-0 font-size-18">{{  trans.get('__JSON__.Contacts')}}</h4>
                            <p>
                                <router-link :to="{name: 'contacts-list',params: { brand_id:base64(typeform.id)}}">{{ trans.get('__JSON__.Contacts') }}</router-link>
                                > {{ trans.get('__JSON__.Edit Contact') }}
                            </p> 
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <form action="" @submit.prevent="editContact">
            <div class="card">
                <div class="card-body">
                <p class="card-title-desc"></p>
                <div class="row">

                    <div class="col-sm-3">
                    <div class="form-group">
                        <label class="required">{{
                        trans.trans("__JSON__.Type")
                        }}</label>
                        <select
                        class="custom-select"
                        id="type"
                        name="type"
                        v-model="$v.typeform.type.$model"    
                        :class="{ 'is-invalid': $v.typeform.type.$error }"
                        >
                        <!-- :class="{ 'is-invalid': $v.ypeform.user_type.$error }" -->
                        <option value="">
                            {{ trans.get("__JSON__.Select Type") }}
                        </option> 

                        <option value="0">
                            {{ trans.get("__JSON__.Person") }}
                        </option>

                        <option value="1">
                            {{ trans.get("__JSON__.Organization") }}
                        </option>
                        </select>
                        <div v-if="$v.typeform.type.$error" class="invalid-feedback">
                        <span v-if="!$v.typeform.type.required">{{
                            trans.get("__JSON__.Please select Customer Type")
                        }}</span>
                        </div>
                    </div>
                    </div>

                    <div class="col-sm-3">
                    <div class="form-group">
                        <label>{{
                        trans.trans("__JSON__.Company Name")
                        }}</label>
                        <input
                            id="company_name"
                            v-model="typeform.company_name"
                            type="text"
                            class="form-control"
                            :placeholder="trans.trans('__JSON__.Company Name')"
                            name="company_name"
                        />
                    </div>
                    </div>

                    <div class="col-sm-3">
                    <div class="form-group">
                        <label>{{
                        trans.trans("__JSON__.Company Branch")
                        }}</label>
                        <input
                            id="company_branch"
                            v-model="typeform.company_branch"
                            type="text"
                            class="form-control"
                            :placeholder="trans.trans('__JSON__.Company Branch')"
                            name="company_branch"
                        />
                    </div>
                    </div>

                    <div class="col-sm-3">
                    <div class="form-group">
                        <label :class="{ 'required': typeform.type == '0' }">{{
                        trans.trans("__JSON__.First Name & Last Name")
                        }}</label>
                        <input
                            id="name"
                            v-model="typeform.user_name"
                            type="text"
                            class="form-control"
                            :placeholder="trans.trans('__JSON__.First Name & Last Name')"
                            name="user_name"
                            :class="{ 'is-invalid': $v.typeform.user_name.$error && typeform.type == '0' }"
                        />
                        <div v-if="$v.typeform.user_name.$error && typeform.type === '0'" class="invalid-feedback"> <!-- Show error only if required -->
                        <span v-if="!$v.typeform.user_name.required">{{
                            trans.get("__JSON__.Please enter your name")
                        }}</span>
                        </div>
                    </div>
                    </div>


                    <div class="col-sm-3">
                    <div class="form-group">
                        <label class="required">{{
                        trans.trans("__JSON__.Role")
                        }}</label>
                        <input
                            id="role"
                            v-model="$v.typeform.role.$model"
                            type="text"
                            class="form-control"
                            :placeholder="trans.trans('__JSON__.Role')"
                            name="role"
                            :class="{ 'is-invalid': $v.typeform.role.$error }"
                        />
                        <div v-if="$v.typeform.role.$error" class="invalid-feedback">
                        <span v-if="!$v.typeform.role.required">{{
                            trans.get("__JSON__.Please enter role")
                        }}</span>
                        </div>
                    </div>
                    </div>

                    <div class="col-sm-3">
                    <div class="form-group">
                        <label>{{
                        trans.trans("__JSON__.Relationship")
                        }}</label>
                        <input
                            id="relationship"
                            v-model="typeform.relationship"
                            type="text"
                            class="form-control"
                            :placeholder="trans.trans('__JSON__.Relationship')"
                            name="relationship"
                        
                        />
                    </div>
                    </div>

                    <div class="col-sm-3">
                    <div class="form-group">
                        <label>{{
                        trans.trans("__JSON__.Street, Postcode and City")
                        }}</label>
                        <input
                            id="address"
                            v-model="typeform.address"
                            type="text"
                            class="form-control"
                            :placeholder="trans.trans('__JSON__.Address')"
                            name="addrees"
                        />
                    </div>
                    </div>

                    <div class="col-sm-3">
                    <div class="form-group">
                        <label>{{
                        trans.trans("__JSON__.E-mail Address")
                        }}</label>
                        <input
                            id="email"
                            v-model="typeform.email"
                            type="email"
                            class="form-control"
                            :placeholder="trans.trans('__JSON__.Email')"
                            name="email"
                        />
                    </div>
                    </div>

                    <div class="col-sm-3">
                    <div class="form-group">
                        <label>{{
                        trans.trans("__JSON__.Private E-mail Address")
                        }}</label>
                        <input
                            id="private_email"
                            v-model="typeform.private_email"
                            type="email"
                            class="form-control"
                            :placeholder="trans.trans('__JSON__.Private E-mail Address')"
                            name="private_email"
                        
                        />
                    </div>
                    </div>

                    <div class="col-sm-3">
                    <div class="form-group">
                        <label>{{
                        trans.trans("__JSON__.Phone Number")
                        }}</label>
                        <input
                            id="phone_number1"
                            v-model="typeform.phone_number1"
                            type="text"
                            class="form-control"
                            :placeholder="trans.trans('__JSON__.Phone Number')"
                            name="phone_number1"
                        />
                    </div>
                    </div>

                    <div class="col-sm-3">
                    <div class="form-group">
                        <label>{{
                        trans.trans("__JSON__.Mobile Phone Number")
                        }}</label>
                        <input
                            id="mobile_phone_number"
                            v-model="typeform.mobile_phone_number"
                            type="text"
                            class="form-control"
                            :placeholder="trans.trans('__JSON__.Mobile Phone Number')"
                            name="mobile_phone_number"
                            
                        />
                    </div>
                    </div>

                    <div class="col-sm-3">
                    <div class="form-group">
                        <label>{{
                        trans.trans("__JSON__.Private Number")
                        }}</label>
                        <input
                            id="private_number"
                            v-model="typeform.private_number"
                            type="text"
                            class="form-control"
                            :placeholder="trans.trans('__JSON__.Private Number')"
                            name="private_number"
                        
                        />
                    </div>
                    </div>

                    <div class="col-sm-3">
                    <div class="form-group">
                        <label>{{
                        trans.trans("__JSON__.Fax Number")
                        }}</label>
                        <input
                            id="fax_number"
                            v-model="typeform.fax_number"
                            type="text"
                            class="form-control"
                            :placeholder="trans.trans('__JSON__.Fax Number')"
                            name="fax_number"
                        />
                    </div>
                    </div>

                    <div class="col-sm-3">
                    <div class="form-group">
                        <label>{{
                        trans.trans("__JSON__.Website-URL / Application URL")
                        }}</label>
                        <input
                            id="url"
                            v-model="typeform.url"
                            type="test"
                            class="form-control"
                            :placeholder="trans.trans('__JSON__.Website-URL / Application URL')"
                            name="url"
                        />
                    </div>
                    </div>

                    <div class="col-sm-3">
                    <div class="form-group">
                        <label>{{
                        trans.trans("__JSON__.Note")
                        }}</label>
                        <input
                            id="note"
                            v-model="typeform.note"
                            type="note"
                            class="form-control"
                            :placeholder="trans.trans('__JSON__.Note')"
                            name="note"
                        />
                    </div>
                    </div>

                    <div class="col-sm-3 vendor-status">
                    <b-form-group
                        id="input-group-1"
                        :label="trans.get('__JSON__.Status')"
                        label-for="status"
                    >
                        <label class="switch">
                        <input
                            type="checkbox"
                            id="togBtn"
                            name="status"
                            class="switch-on"
                            true-value="1"
                            false-value="0"
                            v-model="typeform.status"
                        />
                        <div class="slider round">
                            <span class="on">{{ trans.get("__JSON__.Active") }}</span>
                            <span class="off">{{ trans.get("__JSON__.Inactive") }}</span>
                        </div>
                        </label>
                    </b-form-group>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-3">
                    <button class="btn btn-primary mr-1 mt-3">
                        {{ trans.get("__JSON__.Update Contact") }}
                    </button>
                    <router-link
                        :to="{name:'contacts-list'}"
                    >
                        <b-button
                        type="button"
                        variant="secondary"
                        class="mt-3"
                        >{{ trans.get("__JSON__.Cancel") }}</b-button
                        >
                    </router-link>  
                    </div>
                </div>
                </div>
            </div>
        </form>
    </Layout>
  </template>